export default "__VITE_ASSET__167d41e9__"